const voiceSessionCloseReasonToString = (reason: string): string => {
  const translations: Record<string, string> = {
    END: 'End',
    ABANDON: 'Abandon',
    TIMEOUT: 'Timeout'
  };

  return translations[reason] ?? '-';
};

export default voiceSessionCloseReasonToString;
